import { IAdaptorService } from './../../../base/shared/syncfusion/adaptor-service.interface';
import { ToastService } from '../../../base/services/toast.service';
import {
  IncidentClient,
  IncidentDTO,
  CreateIncidentDTO,
  CreateIncidentMessageDTO,
  FilterDTO,
  SortDirection,
  PagedResultDTOOfIncidentDTO,
  FilterOperator,
  ServiceStatusLevel
} from '../../../base/models/models.swagger.generated';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ErrorType } from 'src/app/core/routing/error-types';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IPagedItems } from 'src/app/base/shared/syncfusion/paged-items.interface';

@Injectable()
export class IncidentsAdministrationService extends ShowInactiveService implements IAdaptorService {

  constructor(
    private incidentClient: IncidentClient,
    private toastService: ToastService,
  ) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<IPagedItems> {
    if (!this.showInactive) {
      if (!filters) {
        filters = [];
      }
      filters.push(new FilterDTO({ isComplex: false, field: 'IsDeleted', operator: FilterOperator.Equal, value: 'false' }));
    }

    return this.incidentClient.searchIncidents(skip, take, sortBy, sortDirection, filters)
      .pipe(
        map(result => ({
          items: result?.items ?? [],
          totalNumberOfItems: result?.totalNumberOfItems ?? 0
        } as IPagedItems)),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public addRecord(data: any): Observable<IncidentDTO> {
    const messages: CreateIncidentMessageDTO[] = [];
    if (data.messages) {
      for (const msg of data.messages) {
        if (msg.message && msg.message.trim()) {
          messages.push(new CreateIncidentMessageDTO({
            language: msg.language,
            message: msg.message,
          }));
        }
      }
    }

    const dto = new CreateIncidentDTO({
      statusServiceId: data.statusServiceId,
      status: data.status as ServiceStatusLevel,
      description: data.description ?? '',
      sendNotification: data.sendNotification ?? false,
      clientIds: data.clientIds ?? [],
      messages: messages
    });

    return this.incidentClient.createIncident(dto)
      .pipe(
        tap(() => {
          this.toastService.showSuccess('i18n.domain.incidents.messages.add-title', 'i18n.domain.incidents.messages.add-success-message');
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public updateRecord(data: any): Observable<any> {
    // Incidents are not editable
    return throwError(() => new Error('Incidents cannot be updated'));
  }

  public deleteRecord(id: number): Observable<any> {
    return this.incidentClient.deleteIncident(id)
      .pipe(
        tap(() => {
          this.toastService.showSuccess('i18n.domain.incidents.messages.delete-title', 'i18n.domain.incidents.messages.delete-success-message');
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }
}
